import InputConfig from '../../../../Components/InputConfig';
import CustomHeading from '../../../../Components/CustomHeading';
import { Grid } from '@mui/material';
import { FEATURE_DESCRIPTION } from '../../constant';
import CheckBoxInput from '../../../../Components/CheckBoxInput';

// Initializing FEATURE_DESCRIPTION
const { SITE_CONFIG } = FEATURE_DESCRIPTION;

const AudioSwitchComponent = ({ aggressiveVpMuteCoverageConfig, updateAggressiveVpMuteCoverageCfg }) => {
	const aggressiveVpmuteCoverageEnabledKey = 'aggressiveVpMuteCoverageConfig.enabled';
	const aggressiveVpmuteCoverageSplitPercentageKey =
		'aggressiveVpMuteCoverageConfig.splitPercentage';
	
	return (
		<>
			<Grid item xs={12} display={'flex'}>
				<CustomHeading
					heading={'Audio Switch'}
					name={`AGGRESSIVE_VP_MUTE_COVERAGE_CONFIG_HEADING`}
					variantType="h6"
					headingStyles={{ marginTop: '1rem' }}
					showInfoButton={true}
					infoMessage={SITE_CONFIG.AGRESSIVE_VP_MUTE_COVERAGE_CONFIG}
				/>
			</Grid>

			<Grid item xs={4}>
				<CheckBoxInput
					keyData={aggressiveVpmuteCoverageEnabledKey}
					label="enabled"
					isObjectEditor={false}
					containerStyles={{ marginTop: '1rem', width: '2rem' }}
					defaultChecked={false}
					directValue={aggressiveVpMuteCoverageConfig?.enabled}
					updateDirectValue={(val) => updateAggressiveVpMuteCoverageCfg('enabled', val)}
				/>
			</Grid>

			<Grid item xs={4}>
				<InputConfig
					label="split percentage"
					keyData={aggressiveVpmuteCoverageSplitPercentageKey}
					editable={!!aggressiveVpMuteCoverageConfig?.enabled}
					isObjectEditor={false}
					inputType="number"
					inputStyles={{ width: '100%' }}
					directValue={aggressiveVpMuteCoverageConfig?.splitPercentage}
					updateDirectValue={(val) => updateAggressiveVpMuteCoverageCfg('splitPercentage', val)}
				/>
			</Grid>
		</>
	);
};

export default AudioSwitchComponent;
